// utils/v3/money.ts — cart money maths (SPEC §6)
// Port of legacy `composables/useJob.ts:calTotalJobItems`.
import type { CartOptionSelection } from '~/types/v3/cart'

export interface MoneyLine {
  qty: number
  price: number
  options2?: CartOptionSelection[] | null
}

export const round2 = (n: number): number => Math.round(n * 100) / 100

/** Σ options2[i].price * (qty || 1) */
export function optionsAddon(item: MoneyLine | null | undefined): number {
  const options = item?.options2
  if (!options || !options.length) return 0
  let addon = 0
  for (const option of options) {
    const price = Number(option?.price) || 0
    const qty = Number(option?.qty) || 1
    addon += price * qty
  }
  return addon
}

/** qty * (price + optionsAddon) */
export function lineTotal(item: MoneyLine | null | undefined): number {
  if (!item) return 0
  const qty = Number(item.qty) || 0
  const price = Number(item.price) || 0
  return qty * (price + optionsAddon(item))
}

/** Legacy `calTotalJobItems` — the RAW sum. This is the `value` the POS gets. */
export function cartTotalRaw(items: readonly MoneyLine[] | null | undefined): number {
  if (!items || !items.length) return 0
  let total = 0
  for (const item of items) total += lineTotal(item)
  return total
}

/** Same sum, rounded — for anything shown on screen. */
export function cartTotal(items: readonly MoneyLine[] | null | undefined): number {
  return round2(cartTotalRaw(items))
}
